// extracted by mini-css-extract-plugin
export default {"root":"DashboardComponentHeading-root-0300b57851089b7e620cf143aca2bded"};